import { where } from 'firebase/firestore'

import FirestoreService from '../../firestoreService'

import { getConvertedData } from '../../../models/interface.helper'

import { EventRegisteredUsersModel } from '../../../models/event-registered-users/event-registered-users.model'
import { TEventRegisteredUsers } from '../../../models/event-registered-users/event-registered-users.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getById = async (id: string) => {
  const eventRegisteredUsersSnaps = await FirestoreService.getItem(
    COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
    id
  )

  return getConvertedData(
    EventRegisteredUsersModel.fromFirestoreDoc(eventRegisteredUsersSnaps).toObject()
  )
}

const getByEventId = async (eventId: string) => {
 const eventRegisteredUsersInDb:TEventRegisteredUsers[] = [];

  const eventRegisteredUsersSnaps = await FirestoreService.filterItems(
    COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
    [where(COLLECTIONS.REGISTRATION_BY_DAY.FIELDS.EVENT_ID.KEY, '==', eventId)]
  )

  eventRegisteredUsersSnaps.docs.forEach((currDoc) => {
    eventRegisteredUsersInDb.push(
      getConvertedData(
        EventRegisteredUsersModel.fromFirestoreDoc(currDoc).toObject()
      ) as EventRegisteredUsersModel
    )
  })

  return eventRegisteredUsersInDb
}

const EventRegisteredUsersService = {
  getById,
  getByEventId,
}
export default EventRegisteredUsersService
